<template>
    <div :id="participantkey + publication[0]">
  </div>
</template>

<script>
export default {
  name: "Audiotrack",
  props: ["participantkey", "publication"],
    data() {
    return {
      ready: false
    }
  },
  mounted() {
    let container = document.getElementById(
      this.participantkey + this.publication[0]
    );
    container.appendChild(this.$props.publication[1].track.attach());
    container.classList.add("audiotrack");
    this.ready = true;
    console.log('add audiotrack');
  }
}
</script>

<style scoped>
.audiotrack {
  position:absolute;
  top:1;
  left:1;
  width: 1vw;
  height: 1vw;
  background-color: transparent;
  overflow: hidden;
}
</style>